export default __webpack_public_path__ + "static/media/ad.853e99da.mp3";